import { ShieldAlert } from 'lucide-react'
import { Button } from '~/components/ui/button'
import RbacStatusPanel from './RbacStatusPanel'

/**
 * Écran bloquant quand aucune autorisation n'a pu être lue de la session (`GET /rbac/me/permissions`
 * en échec ou illisible). Sans elles, le compte n'a aucun droit : on bloque plutôt que d'ouvrir
 * l'interface. La requête retente d'elle-même ; le bouton relance tout de suite.
 */
export default function RbacUnavailablePage({
  query,
  onLogout,
}: {
  /** Requête des autorisations (`useRbacSession`) : le bouton la relance. */
  query: { isFetching: boolean; refetch: () => Promise<unknown> }
  onLogout: () => void
}) {
  return (
    <RbacStatusPanel role="alert">
      <ShieldAlert className="mx-auto mb-4 size-12 text-muted-foreground" />
      <h1 className="mb-3 text-2xl font-semibold">Autorisations indisponibles</h1>
      <p className="mb-6 text-muted-foreground">
        Vos autorisations n'ont pas pu être chargées. Le back-office réessaie automatiquement et
        s'ouvrira dès qu'elles seront disponibles.
      </p>

      <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
        <Button size="lg" onClick={() => void query.refetch()} disabled={query.isFetching}>
          {query.isFetching ? 'Nouvel essai…' : 'Réessayer'}
        </Button>
        <Button size="lg" variant="outline" onClick={onLogout}>
          Déconnexion
        </Button>
      </div>
    </RbacStatusPanel>
  )
}
